import * as React from 'react';

import * as styles from './styles.css';
import { CloseButton } from '../CloseButton';

export interface IFullscreenGalleryHeaderProps {
  onClose(): void;
  title: React.ReactNode;
}

export function Header({ onClose, title }: IFullscreenGalleryHeaderProps) {
  return (
    <div className={styles['container']}>
      {title}
      <div className={styles['aside']}>
        <div data-testid="NewbuildingAdvantagesFullscreenClose" className={styles['close']}>
          <CloseButton onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
